<template>
  <div class="root">
    <div
      class="floating-wrapper"
      @mouseenter="showPopup = true"
      @mouseleave="showPopup = false"
    >
      <div :class="dotColor" class="dot"></div>

      <div class="floating-answer-traffic-lights" v-if="showPopup">
        <span class="traffic-status-text">{{ question() }} </span>
        <span class="traffic-date"> {{ answered() }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "DepDotIndicator.component",
  props: {
    deposit: {
      type: Object,
      required: true
    },
    depositAnswers: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState("clients", ["dictionaries"]),
    dotColor() {
      if (this.deposit.questions_status === 0) {
        return "dot-red";
      }
      if (this.deposit.questions_status === 1) {
        return "dot-yellow";
      }
      return "dot";
    }
  },
  data() {
    return {
      showPopup: false
    };
  },
  methods: {
    answered() {
      if (this.deposit.questions_status > 0) {
        return this.formatDate(
          this.depositAnswers[this.depositAnswers.length - 1].updated_at
        );
      }
    },
    question() {
      if (this.deposit.questions_status === 0) {
        return "Questions Not Answered";
      }
      if (this.deposit.questions_status === 1) {
        return "At Least One Question Answered";
      }
      return "All Questions Answered";
    },
    formatDate(date) {
      return moment(String(date)).format("DD/MM/YY HH:mm");
    }
  }
};
</script>

<style scoped>
.root {
  display: inline;
  float: right;
}

.dot {
  height: 10px;
  width: 10px;
  background-color: #64dd17;
  border-radius: 50%;
  display: inline-block;
}

.dot-green {
  height: 10px;
  width: 10px;
  background-color: #64dd17;
  border-radius: 50%;
  display: inline-block;
}

.dot-yellow {
  height: 10px;
  width: 10px;
  background-color: #ffd600;
  border-radius: 50%;
  display: inline-block;
}

.dot-red {
  height: 10px;
  width: 10px;
  background-color: #d50000;
  border-radius: 50%;
  display: inline-block;
}

.floating-answer-traffic-lights {
  position: absolute;
  top: 14px;
  right: 14px;
  width: max-content;
  z-index: 10001;
  border: solid 1px #ccc;
  padding: 10px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.floating-wrapper {
  position: relative;
}

.traffic-date {
  margin-left: 10px;
}

.traffic-status-text {
  font-weight: 600;
}
</style>
